import CatalogManagement from '@/models/loyaltyPanel/CatalogManagement';
const getDefaultState = () => ({
  gifts: [],
  giftCategories: [],
  gift: new CatalogManagement(),
  deleteDialog: false,
  giftTypes: [],
  suppliers: [],
  synergies: [],
  uploadingImage: null,
  giftsPagination: {},
});

export default {
  namespaced: true,

  state: () => getDefaultState(),

  getters: {
    getGiftCategories(state) {
      return state.giftCategories;
    },
    getDeleteDialog(state) {
      return state.deleteDialog;
    },
    getGift(state) {
      return state.gift;
    },
    getCloseForm(state) {
      return state.closeForm;
    },
    synergies: (state) => state.synergies,
  },

  mutations: {
    resetState(state) {
      Object.assign(state, getDefaultState());
    },
    setGifts(state, payload) {
      state.gifts = payload;
    },
    setGiftCategories(state, payload) {
      state.giftCategories = payload;
    },
    setGift(state, payload) {
      state.gift = new CatalogManagement(payload || {});
    },
    setGiftTypes(state, payload) {
      state.giftTypes = payload;
    },
    setSuppliers(state, payload) {
      state.suppliers = payload;
    },
    setUploadingImage(state, payload) {
      state.uploadingImage = payload;
    },
    setSynergies(state, payload) {
      state.synergies = payload;
    },
    setGiftsPagination(state, payload) {
      state.giftsPagination = payload;
    },
  },

  actions: {
    async getGifts({ commit }, query) {
      try {
        commit('setLoading', true, { root: true });
        const { data } = await CatalogManagement.get(query);

        const { gifts, pagination } = data.data;
        commit('setGifts', gifts);
        commit('setGiftsPagination', pagination);
        commit('setServerItemsLength', pagination.total, {
          root: true,
        });

        commit('setServerPagination', pagination, {
          root: true,
        });
        commit('setLoading', false, { root: true });
      } catch (ex) {
        commit('setLoading', false, { root: true });
      }
    },

    async getGiftTypes({ commit }) {
      try {
        commit('setLoading', true, { root: true });

        const { data } = await CatalogManagement.getGiftTypes();
        const types = data.data;
        commit('setGiftTypes', types);
        commit('setLoading', false, { root: true });
      } catch (ex) {
        commit('setLoading', false, { root: true });
      }
    },

    async getSuppliers({ commit }) {
      try {
        commit('setLoading', true, { root: true });

        const { data } = await CatalogManagement.getSuppliers();
        const suppliers = data.data;
        commit('setSuppliers', suppliers);
        commit('setLoading', false, { root: true });
      } catch (ex) {
        commit('setLoading', false, { root: true });
      }
    },

    async getGiftCategories({ commit }) {
      try {
        commit('setLoading', true, { root: true });
        const { data } = await CatalogManagement.getCategories();
        const giftCategories = data.data;
        commit('setGiftCategories', giftCategories);
        commit('setLoading', false, { root: true });
      } catch (ex) {
        commit('setLoading', false, { root: true });
      }
    },

    async loadSynergies({ commit, state }) {
      try {
        commit('setLoading', true, { root: true });
        let { data } = await CatalogManagement.getSynergies();

        let synergies = data.data.synergies;
        // .map(e => {
        //     let giftSynergy = state.gift.synergies.find(x => x.company_id === e.company_id)
        //     return {
        //         ...e,
        //         enabled: !!giftSynergy,
        //         exclusive_stores: e.stores.filter(s => giftSynergy.exclusive_stores.includes(s.store_id)).map(x => x.store_id)
        //     }
        // })
        commit('setSynergies', synergies);
        commit('setLoading', false, { root: true });
      } catch (ex) {
        commit('setLoading', false, { root: true });
      }
    },

    async fetchGiftData({ commit }, id) {
      try {
        commit('setLoading', true, { root: true });
        const { data } = await CatalogManagement.getGift(id);
        const gift = data.data;

        // commit("setGiftData", gift);
        commit('setLoading', false, { root: true });
      } catch (ex) {
        commit('setLoading', false, { root: true });
      }
    },

    async create({ commit, dispatch, state }, body) {
      try {
        commit('setLoading', true, { root: true });
        if (body.supplier_store_id == null || body.gift_type_id == 2) {
          delete body.supplier_store_id;
        }

        // if(body.gift_type_id == 1){
        // delete body.redeem_company_ids
        // }

        delete body.gift_id;
        delete body.image;
        const { data } = await CatalogManagement.create(body);
        if (state.uploadingImage) {
          const id = data.data.gift.gift_id;
          const fd = new FormData();
          fd.append('image', state.uploadingImage);
          await CatalogManagement.uploadImage(id, fd);
        }

        dispatch('getGifts', '?page=1');
        commit('setUploadingImage', null);
        commit('setLoading', false, { root: true });
        commit('setDialog', false, { root: true });
        commit(
          'setNotification',
          {
            show: true,
            type: 'success',
            text: 'You have successfully created Gift!',
          },
          { root: true }
        );
        return data;
      } catch (ex) {
        commit('setLoading', false, { root: true });
        commit('setErrorMessage', ex.response.data.message, {
          root: true,
        });
        commit(
          'setNotification',
          {
            show: true,
            type: 'error',
            text: ex.response.data.message,
          },
          { root: true }
        );
        setTimeout(() => commit('setErrorMessage', '', { root: true }), 5000);
        return ex.response;
      }
    },

    async update({ commit, dispatch, state }, body) {
      try {
        commit('setLoading', true, { root: true });
        if (body.supplier_store_id == null) {
          delete body.supplier_store_id;
        }
        delete body.image;
        let id = body.gift_id;

        const { data } = await CatalogManagement.update(id, body);
        if (state.uploadingImage) {
          const id = data.data.gift_id;
          const fd = new FormData();
          fd.append('image', state.uploadingImage);
          await CatalogManagement.uploadImage(id, fd);
        }

        dispatch('getGifts', '?page=1');
        commit('setUploadingImage', null);
        commit('setLoading', false, { root: true });
        commit('setDialog', false, { root: true });
        commit(
          'setNotification',
          {
            show: true,
            type: 'success',
            text: 'You have successfully updated Gift!',
          },
          { root: true }
        );
      } catch (ex) {
        commit('setLoading', false, { root: true });
        commit('setErrorMessage', ex.response.data.message, {
          root: true,
        });
        commit(
          'setNotification',
          {
            show: true,
            type: 'error',
            text: ex.response.data.message,
          },
          { root: true }
        );
        setTimeout(() => commit('setErrorMessage', '', { root: true }), 5000);
      }
    },

    async delete({ commit, dispatch }, id) {
      try {
        commit('setLoading', true, { root: true });

        await CatalogManagement.delete(id);

        dispatch('getGifts', '?page=1');
        commit('setDeleteDialog', false, { root: true });
        commit(
          'setNotification',
          {
            show: true,
            type: 'success',
            text: 'You have successfully deleted Gift!',
          },
          { root: true }
        );
        commit('setLoading', false, { root: true });
      } catch (ex) {
        commit('setLoading', false, { root: true });
        commit('setErrorMessage', ex.response.data.message, {
          root: true,
        });
        commit(
          'setNotification',
          {
            show: true,
            type: 'error',
            text: ex.response.data.message,
          },
          { root: true }
        );
        setTimeout(() => commit('setErrorMessage', '', { root: true }), 5000);
      }
    },
  },
};
